import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import IssuesList from '../serviceDesk/IssueList'
import RequestTypeList from '../serviceDesk/request/RequestTypeList'
import { selectADUserInfo } from '../auth/reducer'
import { selectAppList } from '../appStatus/reducer'
import { Container, PageTitle, PageHeader, H3, InfoTooltip } from '../components/index'
import RefreshIcon from '@atlaskit/icon/glyph/refresh'
import AccessStatus from '../accessSelfService/AccessStatus'
import AppStatus from '../appStatus/AppStatus'
import { getUserAccessStatus } from '../accessSelfService/actions'
import { selectIsRequestPending } from '../util/index'


export class HomePage extends Component {  

  render () {
    let {
      appList,
      adUserInfo,
      getAccessPending,
      } = this.props
    let jiraStatus
    if (appList) {
      jiraStatus = appList.find(app => {return app.name.toLowerCase()==='jira'})
    }
    return (
      <div>
        <PageTitle title='Home' />
        <PageHeader title='Build And Agile Tools Self-Service Portal' />
        {
          !appList || !jiraStatus.available ? null : 
          <Container section>
            <IssuesList />
          </Container>
        }
      </div>
    )
  }
}

export default withRouter(connect((state) => {
    return {
        getAccessPending: selectIsRequestPending(state, getUserAccessStatus),
        adUserInfo: selectADUserInfo(state),        
        appList: selectAppList(state)
    }
},{getUserAccessStatus})(HomePage))



// WEBPACK FOOTER //
// ./client/src/home/RequestsFocus.js